import React from 'react';

import './Button.scss';

type ButtonVariant = 'primary' | 'default';
type ButtonSize = 'small' | 'large' | 'icon';
type ButtonIcon = 'back' | 'refresh';

type ButtonComponentProps = {
  onClick?: () => void;
  text?: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  active?: boolean;
  iconType?: ButtonIcon;
};

// reusable button component
function Button({
  text,
  variant = 'default',
  active = true,
  iconType,
  size = iconType ? 'icon' : 'small',
  onClick,
}: ButtonComponentProps) {
  return (
    <div
      className={`button button__${variant}--${size}-${active ? 'active' : 'inactive'}`}
      onClick={() => onClick && onClick()}
    >
      {!iconType && text}
      {iconType === 'back' && <>&#10094;</>}
      {iconType === 'refresh' && <>&#128260;</>}
    </div>
  );
}

export default Button;
